import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NavigationService } from '@core/services/navigation/navigation.service';
import { ProductsService } from '@core/services/products/products.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class VirtualCardCommand extends BaseProductCommand {
  readonly type = 'virtual';
  readonly title = 'Виртуальная карта';
  readonly icon = 'card';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = false;
  readonly settingsNames = ['REQUEST/OPEN_VIRTUAL_CARD'];
  readonly order = 6; // Шестой в actions для card

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService,
    private productsService: ProductsService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/virtual-cards`, {
      state: { parentProduct: context.data }
    });
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): Observable<boolean> | boolean {
    const product = context.data;
    
    // Полная логика скрытия из старого getProductActions:
    // 1. Скрывать для виртуальных карт
    // 2. Скрывать для момент-карт  
    // 3. Скрывать для заблокированных карт
    if (
      product.isVirtual || 
      this.productsService.checkOnMomentCard(product) ||
      product.status === 'block'
    ) {
      return false;
    }

    return true;
  }
}
